module.exports = __webpack_public_path__ + "static/media/washington-black.a961d88d.jpg";